import {
  WSCard,
  WSElement,
  WSFlexBox,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";

import { PaystubDeductionGroup } from "../../types";
import {
  StatementColumn,
  StatementRow,
  StatementTable
} from "../StatementTable";

const DEDUCTION_COLUMNS: StatementColumn[] = [
  { span: "6" },
  { span: "3", align: "end" },
  { span: "3", align: "end" }
];

type Props = {
  deductionGroups: PaystubDeductionGroup[];
  deductionTotalThisPeriod: number;
  deductionTotalYearToDate: number;
  netPayThisPeriod: number;
  netPayYearToDate: number;
  payoutMethodLabel: string;
};

export const PaystubDeductionsCard: React.FC<Props> = ({
  deductionGroups,
  deductionTotalThisPeriod,
  deductionTotalYearToDate,
  netPayThisPeriod,
  netPayYearToDate,
  payoutMethodLabel
}) => {
  const rows: StatementRow[] = [];

  deductionGroups.forEach((group, groupIndex) => {
    rows.push({
      id: `group-${groupIndex}-header`,
      variant: "header",
      cells: [group.label, "This period", "Year to date"]
    });

    group.lines.forEach((line, lineIndex) => {
      rows.push({
        id: `group-${groupIndex}-line-${lineIndex}`,
        variant: "item",
        cells: [
          line.label,
          formatMoney(line.thisPeriod, Currency.USD),
          formatMoney(line.yearToDate, Currency.USD)
        ]
      });
    });
  });

  rows.push({
    id: "deduction-total",
    variant: "subtotal",
    cells: [
      "Deduction total",
      formatMoney(deductionTotalThisPeriod, Currency.USD),
      formatMoney(deductionTotalYearToDate, Currency.USD)
    ]
  });

  rows.push({
    id: "net-pay",
    variant: "net",
    cells: [
      <WSFlexBox.CenterY key="net-pay-label">
        <WSText.ParagraphSm color="gray700" weight="medium">
          Net pay
        </WSText.ParagraphSm>
        <WSText.ParagraphSm color="gray500" ml="XS">
          {payoutMethodLabel}
        </WSText.ParagraphSm>
      </WSFlexBox.CenterY>,
      formatMoney(netPayThisPeriod, Currency.USD),
      formatMoney(netPayYearToDate, Currency.USD)
    ]
  });

  return (
    <WSElement>
      <WSSectionToolbar title="Deductions" />
      <WSCard mt="M">
        <StatementTable columns={DEDUCTION_COLUMNS} rows={rows} />
      </WSCard>
    </WSElement>
  );
};
